import React, { useEffect, useRef } from 'react';
import { useFormikContext } from 'formik';

import { IComposePanelFields } from './compose-panel.types';
import { publishComposeAudience } from '../../../lib/stores/communication.store';

// Renders nothing — subscribes to Formik values and runs the side effects
// (draft autosave, audience-store publish) in effects, not during render.
interface IDraftSyncEffectsProps {
  persistDraft: (values: IComposePanelFields) => void;
}
export const DraftSyncEffects: React.FC<IDraftSyncEffectsProps> = ({ persistDraft }) => {
  const { values } = useFormikContext<IComposePanelFields>();
  // Skip each effect's first run — on mount `values` equals the just-seeded
  // initialValues; each needs its own ref (see ComposePanel/README.md).
  const hasPersistedOnce = useRef(false);
  useEffect(() => {
    if (!hasPersistedOnce.current) {
      hasPersistedOnce.current = true;
      return;
    }
    persistDraft(values);
  }, [values, persistDraft]);
  const hasPushedAudienceOnce = useRef(false);
  useEffect(() => {
    if (!hasPushedAudienceOnce.current) {
      hasPushedAudienceOnce.current = true;
      return;
    }
    // Single Formik→store bridge: every query-facing change (audience shaping
    // AND content edits, typed or draft-reinitialized) lands in the shared store.
    publishComposeAudience({
      contexts: values.contexts,
      audience: values.audience,
      deliveryOption: values.deliveryOption,
      content: { subject: values.subject, bodyHtml: values.bodyHtml, smsBody: values.smsBody }
    });
  }, [
    values.audience,
    values.deliveryOption,
    values.contexts,
    values.subject,
    values.bodyHtml,
    values.smsBody
  ]);
  return null;
};
